import type { CSSObject } from '@emotion/css';

// CSSObject includes non-object types, which breaks object spreading
export type CssProperties = CSSObject;
